/**
 * One-line notes that finishers leave under a quest's "Completed by" list: one per person
 * per quest, plain text on a single line, no links.
 */

export const QUEST_LINE_MAX = 80;

const LINK =
  /(?:[a-z][a-z0-9+.-]*:\/\/|\bwww\.|\b[a-z0-9-]+(?:\.[a-z0-9-]+)*\.(?:com|net|org|io|app|kr|co|me|ly|gg|xyz|info|biz|link|site|dev|so|to|tv|us|uk|jp|cn|ru|de|fr|page|shop|club|online|top)\b)/i;

/** Whitespace and line breaks fold to single spaces; control characters drop. */
export function normalizeQuestLine(raw: string): string {
  return raw
    .replace(/[\u0000-\u0008\u000b-\u001f\u007f-\u009f\u200b-\u200f\u2028-\u202e\u2066-\u2069\ufeff]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export type QuestLineProblem = "empty" | "long" | "link";

/** Why `text` (already normalized) can't be posted, or null when it can. */
export function questLineProblem(text: string): QuestLineProblem | null {
  if (!text) return "empty";
  if (Array.from(text).length > QUEST_LINE_MAX) return "long";
  if (LINK.test(text)) return "link";
  return null;
}
